import { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import Sidebar from '../Sidebar'
import Header from '../Header'
import HeaderFilters from '../HeaderFilters';

import { GiPoliceOfficerHead } from "react-icons/gi";
import { MdCheck, MdLock, MdWhatsapp  } from "react-icons/md";

import { API_BASE } from '../../config/api';

import ReactApexChart from 'react-apexcharts';

function HomeSuperLider() {

const [admin, setAdmin] = useState(null);
const [loadingAdmin, setLoadingAdmin] = useState(true);

useEffect(() => {
    const fetchAdmin = async () => {
        try {
            setLoadingAdmin(true);

            const res = await fetch(`${API_BASE}/api/admin/me`, {
                method: "GET",
                credentials: "include",
            });

            const data = await res.json();

            if (!res.ok || !data.ok) {
                throw new Error(data.message || "No se pudo obtener la información del admin");
            }

            setAdmin(data.data);
        } catch (error) {
            console.error("Error al obtener admin:", error);
            setAdmin(null);
        } finally {
            setLoadingAdmin(false);
        }
    };

    fetchAdmin();
}, []);

// Panel General
    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState("");

    const [distys, setDistys] = useState([]);
    const [grados, setGrados] = useState([]);

    const [distyId, setDistyId] = useState("");
    const [gradoId, setGradoId] = useState("");

    const [startDate, setStartDate] = useState("2026-05-11");
    const [endDate, setEndDate] = useState("2026-11-30");

    const [downloadingExcel, setDownloadingExcel] = useState(false);

    const [summary, setSummary] = useState({
        usuariosRegistrados: 0,
        usuariosActivos: 0,
        usuariosNoActivos: 0,
        usuariosBorrados: 0,
        usuariosMexico: 0,
        usuariosLatam: 0,
        usuariosParticipantes: 0,
        usuariosNoParticipantes: 0,
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

const handleRegionChange = async (value) => {
    setRegionId(value);
    setDistyId("");
    setGradoId("");

    await getFilters({
        nextRegionId: value,
        nextDistyId: "",
    });
};

const handleDistyChange = async (value) => {
    setDistyId(value);
    setGradoId("");

    await getFilters({
        nextRegionId: regionId,
        nextDistyId: value,
        updateRegions: false,
        updateDistys: false,
        updateGrados: true,
    });
};;

const handleGradoChange = (value) => {
    setGradoId(value);
};

    // =============================
    // Cargar filtros iniciales
    // =============================

const getFilters = async ({
    nextRegionId = "",
    nextDistyId = "",
    updateRegions = true,
    updateDistys = true,
    updateGrados = true,
} = {}) => {
    try {
        const params = new URLSearchParams();

        if (nextRegionId) params.append("regionId", nextRegionId);
        if (nextDistyId) params.append("distyId", nextDistyId);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
            throw new Error(result.message || "Error al obtener filtros.");
        }

        if (updateRegions) {
            setRegions(result.data?.regions || []);
        }

        if (updateDistys) {
            setDistys(result.data?.distys || []);
        }

        if (updateGrados) {
            setGrados(result.data?.grados || []);
        }

        return result.data;
    } catch (error) {
        console.error("Error filtros HomeSuperLider:", error);
        setError(error.message);
        return null;
    }
};

useEffect(() => {
    const initFilters = async () => {
        const data = await getFilters({
            updateRegions: true,
            updateDistys: true,
            updateGrados: true,
        });

        const defaultRegionId = String(data?.defaultRegionId || "");

        setRegionId(defaultRegionId);
        setDistyId("");
        setGradoId("");

        setStartDate(data?.defaultStartDate || "2026-05-11");
        setEndDate(data?.defaultEndDate || "2026-11-30");

        if (defaultRegionId) {
            await getFilters({
                nextRegionId: defaultRegionId,
                nextDistyId: "",
                updateRegions: false,
                updateDistys: true,
                updateGrados: true,
            });
        }
    };

    initFilters();
}, []);

    // =============================
    // Cargar resumen super líder
    // =============================
    useEffect(() => {
        if (!regionId) return;

        const getSummary = async () => {
            try {
                setLoading(true);
                setError("");

                const params = new URLSearchParams();

                params.append("regionId", regionId);

                if (distyId) params.append("distyId", distyId);
                if (gradoId) params.append("gradoId", gradoId);
                if (startDate) params.append("startDate", startDate);
                if (endDate) params.append("endDate", endDate);

                const response = await fetch(
                    `${API_BASE}/api/admin/dashboard/superlider-summary?${params.toString()}`,
                    {
                        method: "GET",
                        credentials: "include",
                    }
                );

                const result = await response.json();

                if (!response.ok || !result.success) {
                    throw new Error(result.message || "Error al obtener resumen super líder.");
                }

                setSummary(result.data || {});
            } catch (error) {
                console.error("Error resumen HomeSuperLider:", error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        getSummary();
    }, [regionId, distyId, gradoId, startDate, endDate]);

    const [registrosLogins, setRegistrosLogins] = useState({
        registros: 0,
        logins: 0,
    });

    const [sesionesChart, setSesionesChart] = useState({
        categories: [],
        series: [],
    });

    useEffect(() => {
    if (!regionId) return;

    const getDashboardData = async () => {
        try {
            setLoading(true);
            setError("");

            const params = new URLSearchParams();

            if (regionId) params.append("regionId", regionId);
            if (distyId) params.append("distyId", distyId);
            if (gradoId) params.append("gradoId", gradoId);
            if (startDate) params.append("startDate", startDate);
            if (endDate) params.append("endDate", endDate);

            const queryString = params.toString();

            const [
                summaryResponse,
                registrosLoginsResponse,
                sesionesTimelineResponse,
            ] = await Promise.all([
                fetch(`${API_BASE}/api/admin/dashboard/superlider-summary?${queryString}`, {
                    method: "GET",
                    credentials: "include",
                }),
                fetch(`${API_BASE}/api/admin/dashboard/superlider-registros-logins?${queryString}`, {
                    method: "GET",
                    credentials: "include",
                }),
                fetch(`${API_BASE}/api/admin/dashboard/superlider-sesiones-timeline?${queryString}`, {
                    method: "GET",
                    credentials: "include",
                }),
            ]);

            const summaryResult = await summaryResponse.json();
            const registrosLoginsResult = await registrosLoginsResponse.json();
            const sesionesTimelineResult = await sesionesTimelineResponse.json();

            if (!summaryResponse.ok || !summaryResult.success) {
                throw new Error(summaryResult.message || "Error al obtener resumen super líder.");
            }

            if (!registrosLoginsResponse.ok || !registrosLoginsResult.success) {
                throw new Error(registrosLoginsResult.message || "Error al obtener registros vs logins.");
            }

            if (!sesionesTimelineResponse.ok || !sesionesTimelineResult.success) {
                throw new Error(sesionesTimelineResult.message || "Error al obtener timeline de sesiones.");
            }

            setSummary(summaryResult.data || {});
            setRegistrosLogins(registrosLoginsResult.data || {
                registros: 0,
                logins: 0,
            });

            const chartData = sesionesTimelineResult.data || {};

            setSesionesChart({
                categories: Array.isArray(chartData.categories) ? chartData.categories : [],
                series: Array.isArray(chartData.series) ? chartData.series : [],
            });

        } catch (error) {
            console.error("Error dashboard HomeSuperLider:", error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    getDashboardData();
}, [regionId, distyId, gradoId, startDate, endDate]);

const handleDownloadUsuariosExcel = async (e) => {
    e.preventDefault();

    if (!regionId || downloadingExcel) return;

    try {
        setDownloadingExcel(true);
        setError("");

        const params = new URLSearchParams();

        if (regionId) params.append("regionId", regionId);
        if (distyId) params.append("distyId", distyId);
        if (gradoId) params.append("gradoId", gradoId);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/superlider-usuarios-excel?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        if (!response.ok) {
            throw new Error("No se pudo descargar el archivo.");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "usuarios_super_lider.xlsx";
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error descarga usuarios:", error);
        setError(error.message);
    } finally {
        setDownloadingExcel(false);
    }
};

const chartCategories = Array.isArray(sesionesChart.categories)
    ? sesionesChart.categories
    : [];

const chartSeries = Array.isArray(sesionesChart.series)
    ? sesionesChart.series
    : [];

const hasChartData = chartSeries.length > 0 && chartCategories.length > 0;

const sesionesChartOptions = {
    chart: {
        id: `sesiones-chart-${regionId || "all"}-${distyId || "all"}-${gradoId || "all"}`,
        height: 350,
        type: "line",
        zoom: {
            enabled: false,
        },
        toolbar: {
            show: true,
            tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true,
            },
        },
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        curve: "straight",
        width: 3,
    },
    title: {
        text: gradoId
            ? "Vistas vs completadas"
            : "Completadas por grado",
        align: "left",
    },
    noData: {
        text: "No hay datos disponibles",
    },
    grid: {
        row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
        },
    },
    xaxis: {
        categories: chartCategories,
        labels: {
            rotate: -45,
        },
    },
    yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: {
            formatter: function (value) {
                return Number(value || 0).toFixed(0);
            },
        },
    },
    tooltip: {
        shared: true,
        intersect: false,
    },
};

const loginPercent = registrosLogins.registros > 0
    ? Math.min(100, (registrosLogins.logins / registrosLogins.registros) * 100)
    : 0;

const activeBase = Number(summary.usuariosActivos || 0);

const participantesPercent = activeBase > 0
    ? Math.min(100, (Number(summary.usuariosParticipantes || 0) / activeBase) * 100)
    : 0;

const noParticipantesPercent = activeBase > 0
    ? Math.min(100, (Number(summary.usuariosNoParticipantes || 0) / activeBase) * 100)
    : 0;

  return (
    <>
    <Sidebar/>
    <main class="main-content">
        <Header/>
        <div class="content-inner container-fluid pb-0" id="page_layout">
            
            <HeaderFilters
                title="Datos Básicos"
                subtitle="Panel Super Líder"

                regions={regions}
                distys={distys}
                grados={grados}

                regionId={regionId}
                distyId={distyId}
                gradoId={gradoId}

                startDate={startDate}
                endDate={endDate}

                onRegionChange={handleRegionChange}
                onDistyChange={handleDistyChange}
                onGradoChange={handleGradoChange}
                onStartDateChange={setStartDate}
                onEndDateChange={setEndDate}
            />

            <div className="row">
                <div className="col-lg-6">
                    <div className="row g-4 mb-4">
                        {/* Métricas principales */}
                        <div className="col-xl-8 col-lg-12">
                            <div className="row g-4">
                                {/* Usuarios activos */}
                                <div className="col-md-6">
                                    <div className="card h-100 metric-card-clean">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between gap-3">
                                                <div class="bg-info text-white rounded p-3">
                                                    <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                                                        <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                                                        <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                                                        <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                                                        <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                                                        <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                                                    </svg>
                                                </div>

                                                <div className="text-end">
                                                    <p className="metric-title mb-1">Usuarios activos</p>
                                                    <h2 className="metric-value mb-0">
                                                        {Number(summary.usuariosActivos || 0).toLocaleString("es-MX")}
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Usuarios inactivos */}
                                <div className="col-md-6">
                                    <div className="card h-100 metric-card-clean">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between gap-3">
                                                <div class="bg-secondary text-white rounded p-3">
                                                    <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                                                        <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                                                        <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                                                        <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                                                        <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                                                        <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                                                    </svg>
                                                </div>

                                                <div className="text-end">
                                                    <p className="metric-title mb-1">Usuarios inactivos</p>
                                                    <h2 className="metric-value mb-0">
                                                        {Number(summary.usuariosNoActivos || 0).toLocaleString("es-MX")}
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Participantes */}
                                <div className="col-md-6">
                                    <div className="card h-100 metric-card-clean metric-card-tall">
                                        <div className="card-body d-flex flex-column justify-content-between">
                                            <div class="bg-success text-white rounded p-3" style={{width:'55px'}}>
                                                <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.997 15.1746C7.684 15.1746 4 15.8546 4 18.5746C4 21.2956 7.661 21.9996 11.997 21.9996C16.31 21.9996 19.994 21.3206 19.994 18.5996C19.994 15.8786 16.334 15.1746 11.997 15.1746Z" fill="currentColor"></path>
                                                    <path opacity="0.4" d="M11.9971 12.5838C14.9351 12.5838 17.2891 10.2288 17.2891 7.29176C17.2891 4.35476 14.9351 1.99976 11.9971 1.99976C9.06008 1.99976 6.70508 4.35476 6.70508 7.29176C6.70508 10.2288 9.06008 12.5838 11.9971 12.5838Z" fill="currentColor"></path>
                                                </svg>
                                            </div>

                                            <div>
                                                <div className="d-flex justify-content-between align-items-end gap-2">
                                                    <div>
                                                        <p className="metric-title mb-1">Participantes</p>
                                                        <h3 className="metric-value mb-0">
                                                            {Number(summary.usuariosParticipantes || 0).toLocaleString("es-MX")}
                                                        </h3>
                                                    </div>

                                                    <span className="badge bg-success">
                                                        {participantesPercent.toFixed(1)}%
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* No participantes */}
                                <div className="col-md-6">
                                    <div className="card h-100 metric-card-clean metric-card-tall">
                                        <div className="card-body d-flex flex-column justify-content-between">
                                            <div class="bg-warning text-white rounded p-3" style={{width:'55px'}}>
                                                <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.997 15.1746C7.684 15.1746 4 15.8546 4 18.5746C4 21.2956 7.661 21.9996 11.997 21.9996C16.31 21.9996 19.994 21.3206 19.994 18.5996C19.994 15.8786 16.334 15.1746 11.997 15.1746Z" fill="currentColor"></path>
                                                    <path opacity="0.4" d="M11.9971 12.5838C14.9351 12.5838 17.2891 10.2288 17.2891 7.29176C17.2891 4.35476 14.9351 1.99976 11.9971 1.99976C9.06008 1.99976 6.70508 4.35476 6.70508 7.29176C6.70508 10.2288 9.06008 12.5838 11.9971 12.5838Z" fill="currentColor"></path>
                                                </svg>
                                            </div>

                                            <div>
                                                <div className="d-flex justify-content-between align-items-end gap-2">
                                                    <div>
                                                        <p className="metric-title mb-1">No participantes</p>
                                                        <h3 className="metric-value mb-0">
                                                            {Number(summary.usuariosNoParticipantes || 0).toLocaleString("es-MX")}
                                                        </h3>
                                                    </div>

                                                    <span className="badge bg-warning">
                                                        {noParticipantesPercent.toFixed(1)}%
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Registros vs Logins */}
                        <div className="col-xl-4 col-lg-12">
                            <div className="card h-100 metric-card-clean">
                                <div className="card-body d-flex flex-column justify-content-center">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <div>
                                            <h5 className="mb-1">Registros vs Logins</h5>
                                            <p className="text-muted mb-0">
                                                Tasa de acceso: {loginPercent.toFixed(1)}%
                                            </p>
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <p className="mb-0">Registros</p>
                                            <h4 className="mb-0">
                                                {Number(registrosLogins.registros || 0).toLocaleString("es-MX")}
                                            </h4>
                                        </div>

                                        <div className="progress bg-info-subtle shadow-none w-100" style={{ height: "10px" }}>
                                            <div
                                                className="progress-bar bg-info"
                                                role="progressbar"
                                                aria-valuenow="100"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                                style={{
                                                    width: "100%",
                                                    transition: "width 0.8s ease",
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                            <p className="mb-0">Logins</p>
                                            <h4 className="mb-0">
                                                {Number(registrosLogins.logins || 0).toLocaleString("es-MX")}
                                            </h4>
                                        </div>

                                        <div className="progress bg-success-subtle shadow-none w-100" style={{ height: "10px" }}>
                                            <div
                                                className="progress-bar bg-success"
                                                role="progressbar"
                                                aria-valuenow={loginPercent}
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                                style={{
                                                    width: `${loginPercent}%`,
                                                    transition: "width 0.8s ease",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <div className="header-title">
                                <h4 className="card-title">Sesiones</h4>
                            </div>

                            {loading && (
                                <small className="text-muted">
                                    Actualizando...
                                </small>
                            )}
                        </div>

                        <div className="card-body">
                            {hasChartData ? (
                                <ReactApexChart
                                    key={`chart-${regionId || "all"}-${distyId || "all"}-${gradoId || "all"}-${startDate}-${endDate}`}
                                    options={sesionesChartOptions}
                                    series={chartSeries}
                                    type="line"
                                    height={350}
                                />
                            ) : (
                                <div className="text-center py-5">
                                    <p className="text-muted mb-0">
                                        No hay información de sesiones para graficar.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12">
                    <div class="header-title">          
                </div>
                    <div className="row">
                        <div class="col-lg-4 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                <div class="d-flex align-items-center justify-content-between mt-3">
                                    <div>
                                        <div class="text-center">Descarga Base de Datos</div>
                                    </div>
                                    <a
                                        href="#"
                                        onClick={handleDownloadUsuariosExcel}
                                        className={`text-decoration-none ${!regionId || downloadingExcel ? "pe-none opacity-75" : ""}`}
                                        title={downloadingExcel ? "Descargando..." : "Descargar Excel"}
                                    >
                                        <div className="border bg-success-subtle rounded p-3 d-flex align-items-center justify-content-center">
                                            {downloadingExcel ? (
                                                <div
                                                    className="spinner-border spinner-border-sm text-success"
                                                    role="status"
                                                    style={{
                                                        width: "24px",
                                                        height: "24px",
                                                    }}
                                                >
                                                    <span className="visually-hidden">Descargando...</span>
                                                </div>
                                            ) : (
                                                <svg
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        d="M17.4101 12.1415C17.2839 11.9075 17.0438 11.7616 16.7827 11.7616H12.7173V3.73429C12.7173 3.32896 12.396 3 12 3C11.6041 3 11.2828 3.32896 11.2828 3.73429V11.7616H7.21731C6.95527 11.7616 6.71523 11.9075 6.58995 12.1415C6.46275 12.3755 6.47136 12.6614 6.61003 12.8875L11.3927 20.6573C11.5247 20.8708 11.7533 21 12 21C12.2468 21 12.4753 20.8708 12.6073 20.6573L17.39 12.8875C17.4627 12.7681 17.5 12.632 17.5 12.4959C17.5 12.3745 17.4694 12.2521 17.4101 12.1415Z"
                                                        fill="currentColor"
                                                    />
                                                </svg>
                                            )}
                                        </div>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                <div class="d-flex align-items-center justify-content-between mt-3">
                                    <div>
                                        <div class="text-center">Descarga University of Panduit</div>
                                    </div>
                                    <a href='/listado-usuarios'>
                                    <div class="border  bg-info-subtle rounded p-3">
                                        <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M17.4101 12.1415C17.2839 11.9075 17.0438 11.7616 16.7827 11.7616H12.7173V3.73429C12.7173 3.32896 12.396 3 12 3C11.6041 3 11.2828 3.32896 11.2828 3.73429V11.7616H7.21731C6.95527 11.7616 6.71523 11.9075 6.58995 12.1415C6.46275 12.3755 6.47136 12.6614 6.61003 12.8875L11.3927 20.6573C11.5247 20.8708 11.7533 21 12 21C12.2468 21 12.4753 20.8708 12.6073 20.6573L17.39 12.8875C17.4627 12.7681 17.5 12.632 17.5 12.4959C17.5 12.3745 17.4694 12.2521 17.4101 12.1415Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                <div class="d-flex align-items-center justify-content-between mt-3">
                                    <div>
                                        <div class="text-center">Añadir o retirar Usuarios </div>
                                    </div>
                                    <a href='/listado-usuarios'>
                                    <div class="border  bg-secondary-subtle rounded p-3">
                                        <svg fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                            <path d="M12.1415 6.5899C11.9075 6.71614 11.7616 6.95618 11.7616 7.21726V11.2827H3.73429C3.32896 11.2827 3 11.604 3 12C3 12.3959 3.32896 12.7172 3.73429 12.7172H11.7616V16.7827C11.7616 17.0447 11.9075 17.2848 12.1415 17.4101C12.3755 17.5372 12.6614 17.5286 12.8875 17.39L20.6573 12.6073C20.8708 12.4753 21 12.2467 21 12C21 11.7532 20.8708 11.5247 20.6573 11.3927L12.8875 6.60998C12.7681 6.5373 12.632 6.5 12.4959 6.5C12.3745 6.5 12.2521 6.5306 12.1415 6.5899Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </>
  )
}

function DashboardCard({ title, value }) {
    return (
        <div className="col-md-3">
            <div className="card">
                <div className="card-body">
                    <p className="mb-1">{title}</p>
                    <h3 className="mb-0">
                        {Number(value || 0).toLocaleString("es-MX")}
                    </h3>
                </div>
            </div>
        </div>
    );
}

export default HomeSuperLider